import { TopToolbar } from "react-admin";
import { Box } from "@mui/material";
import ThesisDefenseInfo from "./ThesisDefenseInfo";

const ListActionsToolbar = ({ internshipSessionId }) => {
  return (
    <TopToolbar sx={{ width: "100%", justifyContent: "flex-start" }}>
      <Box sx={{ width: "100%", mb: 2 }}>
        {internshipSessionId && <ThesisDefenseInfo internshipSessionId={internshipSessionId} />}
      </Box>
    </TopToolbar>
  );
};

export default ListActionsToolbar;
